module.exports = "\n.video-wrap{\n    max-width: 100%;\n    height: 100%;\n    margin: auto;\n    \n}\n.video-js{margin:auto; width: 100%; height: 100%; background-color: #000; }\n.my-player-dimensions {\n    width: 100%;\n    height: 100%;\n}\n.backbtn{\n    font-size: 20px;\n    color: #fff;\n    padding: 10px;\n    border-radius: 5px;\n    position: absolute;\n    top: 30px;\n    background-color: #3c94ff;\n    left: 30px;\n    z-index: 9;\n}\n.bg{\n    background-color: #000;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/video-js/video-js.component.css
// module id = ./src/app/video-js/video-js.component.css
// module chunks = main